import { createBrowserRouter, Outlet } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { LoginRoutes } from './login';
import { AppRoutes } from './app';

import { AuthLoader } from 'features/auth/components/AuthLoader';
import { CacheIdentityGuard } from 'features/auth/components/CacheIdentityGuard';
import { ErrorBoundary } from 'components/errorBoundary/ErrorBoundary';
import { RouteError } from 'components/routeError/RouteError';

// wrapCreateBrowserRouterV6 may not be in TypeScript types but exists at runtime in Sentry v10
const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

// Wrapper for public routes that only need error boundary (no auth)
const PublicLayout = () => (
  <ErrorBoundary>
    <Outlet />
  </ErrorBoundary>
);

// The guard sits OUTSIDE AuthLoader on purpose. AuthLoader renders a loader instead of its
// children while the user query is pending, so as a child the guard was unmounted by its own
// queryClient.clear() — losing the in-flight re-entry ref and busting again on remount, until
// the async marker write landed (DL-67243: five refetches of the boot queries per switch).
const AuthenticatedLayout = () => (
  <ErrorBoundary>
    <CacheIdentityGuard />
    <AuthLoader>
      <Outlet />
    </AuthLoader>
  </ErrorBoundary>
);

export const router = sentryCreateBrowserRouter([
  // Public routes (login, signup, etc.)
  {
    element: <PublicLayout />,
    errorElement: <RouteError />,
    children: [...LoginRoutes],
  },
  // Protected routes - wrapped by AuthLoader
  {
    element: <AuthenticatedLayout />,
    errorElement: <RouteError />,
    children: [...AppRoutes, { path: '*', element: <div>Not found</div> }],
  },
]);
